<script>
import apiConnector from '../../apiConnector';
import error from '../error';
import vSelect2 from '../vSelect2';

export default {
  name: 'paisTeams',
  template: '#pais-teams-vue',
  components: {
    error,
  },
  props: ['loadTeam', 'persisted', 'canManage'],
  data() {
    return {
      error: false,
      paisTeams: [],
      attributes: ['id', 'created_who', 'updated_who', 'user_id', 'notes', 'status'],
      firstLoad: true,
    };
  },
  mounted() {
    eventBus.$on('savePaiTeam', (result) => {
      if (result.index != null) {
        this.$set(this.paisTeams, result.index, result.data);
      } else {
        this.paisTeams.push(result.data);
      }
      $('#modal-pai-team').modal('hide');
      Loader.hide();
    });
    if (this.persisted) {
      var tab = $('#team-tab');
      if (tab.length > 0) {
        tab.on('shown', () => this.loadPaisTeams());
        if (location.href.split('#', 2)[1] === tab.prop('href').split('#', 2)[1]) {
          // if page lands on http://...pais/n/edit#tab_pais_teams
          this.loadPaisTeams();
        }
      } else {
        this.loadPaisTeams();
      }
    } else {
      eventBus.$on('pai_elements', (elements) => {
        this.paisTeams = elements['pais_teams'];
        eventBus.$emit('jobDecodes', elements.job_decodes);
      });
      eventBus.$emit('paiTargetOrTeamMounted');
    }
  },
  methods: {
    loadPaisTeams() {
      if (this.firstLoad) {
        this.error = false;
        Loader.show();
        apiConnector()
          .get(this.loadTeam)
          .then((res) => {
            this.paisTeams = res.data.results;
            eventBus.$emit('jobDecodes', res.data.job_decodes);
            this.firstLoad = false;
            Loader.hide();
          })
          .catch((err) => {
            Loader.hide();
            this.error = true;
          });
      }
    },
    openModal(paiTeam, index) {
      this.error = false;
      Loader.show();
      eventBus.$emit('openModalTeam', { data: paiTeam, index: index });
    },
    removePaisTeam(paisTeam) {
      this.error = false;
      Loader.show();
      if (this.persisted) {
        $.each(this.paisTeams, (i, p) => {
          if (p === paisTeam) {
            this.$set(p, 'status', 2);
          }
        });
      } else {
        this.paisTeams = this.paisTeams.filter((t) => t !== paisTeam);
      }
      Loader.hide();
    },
  },
};
</script>
